import { styled } from '@mui/material';
import MuiTextField from '@mui/material/TextField';
import { spacing } from '@mui/system';
import { forwardRef, KeyboardEvent } from 'react';
import { TextFieldProps } from './model/TextFieldProps';

type Props = TextFieldProps & {
  onEnterKeyDown?(event: KeyboardEvent<HTMLInputElement>): void;
};

const StyledTextField = styled(MuiTextField, {
  shouldForwardProp: prop => prop !== 'flexBasis' && prop !== 'marginBottom',
})<TextFieldProps>`
  ${spacing}
  flex-basis: ${(props: TextFieldProps): string | undefined => props.flexBasis};
`;

export const TextField = forwardRef<HTMLDivElement, Props>(function TextField(props, ref) {
  const { variant = 'outlined', onEnterKeyDown, required = false, ...otherProps } = props;

  const handleOnKeydown = (event: KeyboardEvent<HTMLInputElement>): void => {
    const wasEnterPressed = event.key === 'Enter';

    if (props.onKeyDown) {
      props.onKeyDown(event);
    }
    if (onEnterKeyDown && wasEnterPressed) {
      onEnterKeyDown(event);
    }
  };

  return (
    <StyledTextField
      required={required}
      inputRef={ref}
      variant={variant}
      autoComplete="off"
      {...otherProps}
      onKeyDown={handleOnKeydown}
    />
  );
});
